import { render } from "./Submissions.vue?vue&type=template&id=2ffef0c1&scoped=true"
import script from "./Submissions.vue?vue&type=script&lang=js"
export * from "./Submissions.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2ffef0c1"

export default script